import DAO from './DAO.js';
import OfflineQueue from './queue/OfflineQueue';
import uniqueDocumentsServices from '../services/uniqueDocumentsServices';
import StoreItemProcessing from '../helpers/StoreFunctions/StoreItemProcessing';

export default class UniqueDocumentsDAO extends DAO {

  constructor(store) {
    super(store, 'unique_document');
    this.OfflineQueue = OfflineQueue;

    this.unsetUniqueDocument = this.unsetUniqueDocument.bind(this);
    this.clearUniqueDocuments = this.clearUniqueDocuments.bind(this);
  }

  unsetUniqueDocument(id) {
    StoreItemProcessing.deleteItemInStore(this.itemType, id);
  }

  clearUniqueDocuments() {
    StoreItemProcessing.clearItemsInStore(this.itemType);
  }

  getUniqueDocument(docId, options) {
    if (!options) {
      options = { recordDescriptor: { unique_document: { conversions: { additionalFields: ['upload'] } }, additionalFields: ['attachment'] } }; 
    }
    return this._getItem(docId, uniqueDocumentsServices.getUniqueDocument.bind(this, docId, options), options);
  }

  handleActionCableAndGetRequest(acData) {
    const uniqueDocument = this.findItem(acData.unique_document_id);
    if (uniqueDocument) {
      if (acData.is_attribute_update) {
        this.markNeedsAttributeSync(uniqueDocument);
      }
      else {
        this.markNeedsSync(uniqueDocument);
      }
      switch (acData.type) {
      case 'newUniqueDocument':
      case 'updateUniqueDocument':
        return this.getUniqueDocument.bind(this);
      case 'deleteUniqueDocument':
        break;
      default:
      }
    }
  }

  clearState(options) {
    this.clearMyState(this.stateTree.new_unique_documents, options.toIgnore.uniqueDocuments, this.unsetUniqueDocument, this.clearUniqueDocuments, options);
  }
}



// WEBPACK FOOTER //
// ./src/dao/UniqueDocumentsDAO.js